/**
 * LINE 官方帳號 API Service（#24-B2 Phase A）。
 * SYSTEM_ADMIN 平台 view（全租戶）+ 租戶 admin 自 org。憑證只進不出。
 */
import axiosInstance from '../../../../api/axios';

const BASE = '/api/ee/line-oa';

export interface LineOa {
  id: number;
  org_id: number;
  channel_id: string;
  bot_basic_id?: string | null;
  display_name?: string | null;
  is_active: boolean;
  has_secret: boolean;
  webhook_verified_at?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface LineOaCreate {
  org_id?: number;
  channel_id: string;
  channel_secret: string;
  channel_access_token: string;
  bot_basic_id?: string;
  display_name?: string;
}

export interface MessageLogItem {
  id: number;
  direction: string;
  line_user_id?: string | null;
  event_type?: string | null;
  reply_status?: string | null;
  created_at?: string | null;
}

export interface MessageLogResult {
  total: number;
  items: MessageLogItem[];
  quota_used: number;
  quota_limit: number;
  quota_warning: number;
  over_warning: boolean;
}

export const getOwnOa = async (): Promise<LineOa | null> => {
  const res = await axiosInstance.get<LineOa | null>(BASE);
  return res.data;
};

export const listAllOa = async (): Promise<LineOa[]> => {
  const res = await axiosInstance.get<LineOa[]>(`${BASE}/all`);
  return res.data;
};

export const createOa = async (data: LineOaCreate): Promise<LineOa> => {
  const res = await axiosInstance.post<LineOa>(BASE, data);
  return res.data;
};

export const updateOa = async (id: number, data: Partial<LineOaCreate> & { is_active?: boolean }): Promise<LineOa> => {
  const res = await axiosInstance.put<LineOa>(`${BASE}/${id}`, data);
  return res.data;
};

export const deleteOa = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${id}`);
};

export const verifyWebhook = async (id: number): Promise<LineOa> => {
  const res = await axiosInstance.post<LineOa>(`${BASE}/${id}/verify-webhook`);
  return res.data;
};

export const pushMessage = async (id: number, to: string, message: string): Promise<void> => {
  await axiosInstance.post(`${BASE}/${id}/push`, { to, message });
};

export const broadcast = async (id: number, message: string): Promise<void> => {
  await axiosInstance.post(`${BASE}/${id}/broadcast`, { message });
};

export const getMessages = async (id: number, direction?: 'in' | 'out'): Promise<MessageLogResult> => {
  const res = await axiosInstance.get<MessageLogResult>(`${BASE}/${id}/messages`, {
    params: direction ? { direction } : undefined,
  });
  return res.data;
};
